import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import EmbeddedTypeGroupBoxViewModelType from '@/ViewModels/Controls/EmbeddedTypeGroupBoxViewModel';
import EmbeddedTypeGroupBoxType from '@/Controls/EmbeddedTypeGroupBox';
import LabelViewModelType from '@/ViewModels/Controls/LabelViewModel';
import ResourceManager from '@/Management/ResourceManager';
import { IEmbeddedTypeGroupBoxFactoryConstructorParameter } from '#/DefaultViewExtensionInterfaces';

export default class EmbeddedTypeGroupBoxFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private EmbeddedTypeGroupBoxViewModel = ComponentManager.getViewModel<typeof EmbeddedTypeGroupBoxViewModelType>('EmbeddedTypeGroupBoxViewModel');
    private EmbeddedTypeGroupBox = ComponentManager.getControl<typeof EmbeddedTypeGroupBoxType>('EmbeddedTypeGroupBox');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelType>('LabelViewModel');

    public constructor(private params: IEmbeddedTypeGroupBoxFactoryConstructorParameter) {
        super(params);
    }

    /**
     * @override
     */
    control: EmbeddedTypeGroupBoxType;
    /**
     * @override
     */
    viewModel: EmbeddedTypeGroupBoxViewModelType;

    /**
     * @override
     * @inheritdoc
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        if (this.labelPosition === 'Left')
            this.labelPosition = 'Top';

        this.viewModel = this.createViewModel();

        this.control = this.createControl();

        const tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }

    protected createViewModel(): EmbeddedTypeGroupBoxViewModelType {
        let children;
        if (this.params.sortAlphabetically) {
            children = _.sortBy(this.detailViewItem.children, (child) => ResourceManager.getInstance().get(child.ergName));
        } else {
            children = this.detailViewItem.children;
        }

        return new this.EmbeddedTypeGroupBoxViewModel({
            factory: this,
            layout: this.layout || 'EmbeddedGroupLayout',
            isRequired: this.isRequired,
            isDisplayed: this.isDisplayed,
            context: this.context,
            locator: this.locator,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            children: children,
            label: new this.LabelViewModel({
                ergName: this.detailViewItem.ergName
            })
        });
    }

    protected createControl(): EmbeddedTypeGroupBoxType {
        return new this.EmbeddedTypeGroupBox(this.viewModel);
    }

}

ComponentManager.setFactory('EmbeddedTypeGroupBox', EmbeddedTypeGroupBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');